import './style.modules.scss'

import { CardFeatureFlag, FeatureFlagProps } from '@ampcore/adel-react'
import { Link, LinkProps, LinkVariant } from '@ampcore/adel-react'
import { BackgroundColor } from '@ampcore/ampcom-contracts'
import { AnalyticsTagBuilder } from '@dai-team/analytics-library'
import React, { forwardRef } from 'react'
import xss from 'xss'

import { rteContentFilter } from '../../lib/helpers/rteContentFilter'
import { RightRailCardBackgroundColor } from './RightRailCardColor.type'

export type RightRailCardProps = {
  heading?: string
  body?: string
  backgroundColor?: RightRailCardBackgroundColor
  featureFlag?: FeatureFlagProps
  link?: LinkProps
  className?: string
  analyticsName?: string
  personalizationId?: string
  testId?: string
}

export const RightRailCard = forwardRef<HTMLAnchorElement, RightRailCardProps>(
  (props, ref) => {
    let cardBackground, backgroundImage
    const {
      className,
      testId,
      heading,
      body,
      backgroundColor,
      featureFlag,
      link
    } = props

    const atb = new AnalyticsTagBuilder().setDefaultName('RightRailCard')

    if (
      (!heading || heading.trim().length === 0) &&
      (!body || body.trim().length === 0)
    ) {
      return null
    }

    switch (backgroundColor) {
      case BackgroundColor.MINT_TINT:
        cardBackground = 'u-bgColorMintLight10'
        break
      case BackgroundColor.PURPLE_TINT:
        cardBackground = 'u-bgColorPurpleLight10'
        break
      case BackgroundColor.LIME_TINT:
        cardBackground = 'u-bgColorLimeLight20'
        break
      case BackgroundColor.BERRY_TINT:
        cardBackground = 'u-bgColorBerryLight10'
        break
      case BackgroundColor.ORANGE_TINT:
        cardBackground = 'u-bgColorOrangeLight20'
        break
      case BackgroundColor.WHITE_FACET:
        backgroundImage = `url(${window.AMPCOMPATH}images/facets/right-rail-card/right-rail-card-facets-white.png)`
        break
      default:
        cardBackground = 'u-bgColorStone'
    }

    return (
      <div
        className={`RightRailCard u-marginBottom32 ${className || ''} ${
          featureFlag?.label && featureFlag?.label !== ''
            ? 'RightRailCard--withFeatureFlag'
            : ''
        }`}
        {...atb.dataAnalyticAttribute('cta')}
        data-testid={testId ? `${testId}` : null}
      >
        {featureFlag?.label && (
          <CardFeatureFlag
            backgroundColor={featureFlag.backgroundColor}
            label={featureFlag.label}
          />
        )}
        <div
          className={`RightRailCard-content ${cardBackground || ''}`}
          style={{ background: backgroundImage }}
          data-testid={testId ? `${testId}-content` : null}
        >
          {heading && (
            <h5
              className="RightRailCard-heading Type-3 u-textBold u-paddingBottom8"
              data-testid={testId ? `${testId}-heading` : null}
              dangerouslySetInnerHTML={{ __html: xss(heading) }}
            />
          )}
          {body && (
            <div
              className="RightRailCard-body Content u-paddingBottom32"
              data-testid={testId ? `${testId}-body` : null}
              dangerouslySetInnerHTML={{ __html: rteContentFilter(body) }}
            ></div>
          )}
          {link?.name && link?.url && (
            <Link
              ref={ref}
              variant={LinkVariant.SECONDARY}
              className="u-textNoWrap"
              url={link.url}
              target={link.target}
              ariaLabel={link.ariaLabel}
              {...atb.dataAnalyticAttribute('cta-click')}
              data-testid={testId ? `${testId}-button` : null}
              name={link.name}
            />
          )}
        </div>
      </div>
    )
  }
)
